import { render, staticRenderFns } from "./ClearCanvasUI.vue?vue&type=template&id=740f23a8&scoped=true&"
import script from "./ClearCanvasUI.vue?vue&type=script&lang=js&"
export * from "./ClearCanvasUI.vue?vue&type=script&lang=js&"
import style0 from "./ClearCanvasUI.vue?vue&type=style&index=0&id=740f23a8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f23a8",
  null
  
)

export default component.exports